$('#searchForm').submit(function () {
    if (!$(this).valid()) return false;
    $('#advanced-search-submit-btn').prop('disabled', true).html('Searching ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
});

$('#searchForm').validate({
    rules: {
        topic_id: {
            required: true,
        },
        acyr: {
            required: true,
        },
        block: {
            required: true,
        },
    },
    messages: {
        block: {
            required: 'Please select a block',
        },
        topic_id: {
            required: 'Please choose a specialty',
        },
        acyr: {
            required: 'Please choose an academic year',
        },
    },
});

$('#quickSearchForm').validate({
    rules: {
        student_id: {
            required: true,
        },
    },
    messages: {
        student_id: {
            required: 'Please select a student',
        },
    },
});

$('#quickSearchForm').submit(function () {
    if (!$(this).valid()) return false;
    $('#student-quick-search-btn').prop('disabled', true).html('Searching ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
});
